"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateEmail = void 0;
function ValidateEmail(email) {
    if (typeof email !== "string")
        return false;
    return new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(email);
}
exports.ValidateEmail = ValidateEmail;
//# sourceMappingURL=ValidateEmail.js.map